import { useState, useEffect } from 'react';
import moment from 'moment';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import ComplaintShimmer from './ComplaintShimmer';
import { MetaTags } from 'react-meta-tags';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Badge, Button } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
//Import Flatepicker
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';

import {
  Col,
  Container,
  Row,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Offcanvas,
  OffcanvasBody,
} from 'reactstrap';
import { DashBreadcrumb } from '../../../../components/Common/Breadcrumb';
import { TextArea } from 'semantic-ui-react';
import {
  getServiceOrderDetails,
  assignToTechnician,
  getTechniciansList,
  getPurchaseOrderDetails,
  sendWhatsAppMessage,
  updateStatus,
  updatePurifierOrder,
  getModelList,
  getInventoryByModel,
  makeFreeService,
} from '../actions/action';
import toast, { Toaster } from 'react-hot-toast';
import GoogleMaps from '../../../../components/maps/GoogleMaps';
import AddAddress from '../../../Orders/Cart/components/AddAddress';
import { FREE_SERVICE_ALLOWED_USER_ROLES } from '../../../../constants';

const noImage = 'https://assets.danubehome.com/media/wysiwyg/svg/noImage.svg';

const ServiceOrdersDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const users = JSON.parse(localStorage?.getItem('authUser'));

  useEffect(() => {
    getServiceOrderDetails({
      params: {
        service_no: id,
      },

      dispatch,
    });
  }, [id]);
  const {
    serviceOrderDetail = [],
    purchaseOrderDetail = [],
    isLoading,
  } = useSelector((state) => state.complaints);

  const serviceOrderDetailData = serviceOrderDetail?.serviceDetails || [];

  const serviceOrderPurchaseDetailData = purchaseOrderDetail?.data || [];

  const styles = {
    bgGreen: {
      backgroundColor: '#13af1bff',
    },
    bgGreenLight: {
      backgroundColor: '#54c95aff',
    },
    bgGray: {
      backgroundColor: '#a0a0a0ff',
    },
    bgGrayLight: {
      backgroundColor: '#d3d3d3ff',
    },
    bgRedLight: {
      backgroundColor: '#faadb3ff',
    },
    textGray: {
      color: '#6c757d',
    },
    textGreen: {
      color: '#13af1bff',
    },
    textGreenLight: {
      color: '#54c95aff',
    },
    textRed: {
      color: '#dc3545',
    },
  };

  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [selectedTechnician, setSelectedTechnician] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [comment, setComment] = useState('');
  const [scheduledDate, setScheduledDate] = useState(null);
  const [statusError, setStatusError] = useState('');
  const [commentError, setCommentError] = useState('');
  const [scheduledDateError, setScheduledDateError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  // State for Update Location Offcanvas
  const [updateLocationOpen, setUpdateLocationOpen] = useState(false);
  const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
  const [modelList, setModelList] = useState([]);
  // Inventory drawer state
  const [inventoryOpen, setInventoryOpen] = useState(false);
  const [inventoryLoading, setInventoryLoading] = useState(false);
  const [inventoryData, setInventoryData] = useState(null);
  const [inventoryTab, setInventoryTab] = useState('consumables');
  const [expandedAmc, setExpandedAmc] = useState({});
  const [isDownloadingInvoice, setIsDownloadingInvoice] = useState(false);
  // Make Free Service drawer state
  const [freeServiceOpen, setFreeServiceOpen] = useState(false);
  const [freeServiceRemark, setFreeServiceRemark] = useState('');
  const [freeServiceAck, setFreeServiceAck] = useState(false);
  const [freeServiceRemarkError, setFreeServiceRemarkError] = useState('');
  const [freeServiceAckError, setFreeServiceAckError] = useState('');
  // Feedback rating drawer
  const [feedbackDrawerOpen, setFeedbackDrawerOpen] = useState(false);

  const toggleAmcItems = (idx) =>
    setExpandedAmc((prev) => ({ ...prev, [idx]: !prev[idx] }));
  const [orderForm, setOrderForm] = useState({
    ls_order_no: '',
    model_no: '',
    complaint_no: '',
    serial_no: '',
    warranty: '',
    installation_date: '',
    warranty_end_date: '',
    amc_start_date: '',
    amc_end_date: '',
    sku: '',
    master_id: '',
  });

  //fetch technicians list
  useEffect(() => {
    getTechniciansList({ dispatch });
    const fetchModels = async () => {
      try {
        const response = await getModelList();
        const rawData = Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : []);
        if (rawData.length > 0) {
          const uniqueNames = [...new Set(rawData.map(item => item.name))].filter(Boolean);
          setModelList(uniqueNames);
        }
      } catch (error) {
        console.error('Error fetching models:', error);
      }
    };
    fetchModels();
  }, []);

  // When status switches to "Assigned to Technician", prefill the comment
  // with the original "New" (status=11) remark from service history.
  useEffect(() => {
    if (selectedStatus !== 'Assigned to Technician') return;
    const newEntry = serviceOrderDetailData?.serviceHistory?.find(
      (h) => String(h?.status) === '11',
    );
    if (newEntry?.remark) {
      setComment(newEntry.remark);
    }
  }, [selectedStatus, serviceOrderDetailData?.serviceHistory]);

  const { techniciansList } = useSelector((state) => state.technician);
  const [addressModal, setAddressModal] = useState(false);
  const [whatsappConfirmModal, setWhatsappConfirmModal] = useState(false);
  const [purchaseDetailsOpen, setPurchaseDetailsOpen] = useState(false);

  const technicians = techniciansList?.technicians || [];

  const toggleAddressModal = () => setAddressModal(!addressModal);
  const toggleWhatsappConfirmModal = () =>
    setWhatsappConfirmModal(!whatsappConfirmModal);
  const togglePurchaseDetails = async (soNumber) => {
    // Fetch purchase order details before opening the Offcanvas
    setIsSubmitting(true);
    await getPurchaseOrderDetails({
      params: { so_number: soNumber },
      dispatch,
    });
    setPurchaseDetailsOpen(!purchaseDetailsOpen);
    setIsSubmitting(false);
  };

  const toggleOrderDetails = () => {
    if (!orderDetailsOpen) {
      // Pre-fill when opening
      setOrderForm({
        ls_order_no: serviceOrderDetailData?.main_order_ref || '',
        model_no: serviceOrderDetailData?.product_purchase_details?.model || '',
        complaint_no: serviceOrderDetailData?.service_order_no || '',
        serial_no: serviceOrderDetailData?.product_purchase_details?.serial_no || '',
        warranty: serviceOrderDetailData?.product_purchase_details?.warranty || '',
        installation_date: serviceOrderDetailData?.product_purchase_details?.installation_date || '',
        warranty_end_date: serviceOrderDetailData?.product_purchase_details?.warranty_end_date || '',
        amc_start_date: serviceOrderDetailData?.product_purchase_details?.amc_start_date || '',
        amc_end_date: serviceOrderDetailData?.product_purchase_details?.amc_end_date || '',
        sku: serviceOrderDetailData?.product_purchase_details?.sku || '',
        master_id: serviceOrderDetailData?.master_id || serviceOrderDetailData?.product_purchase_details?.master_id || '',
      });
    }
    setOrderDetailsOpen(!orderDetailsOpen);
  };

  // Open the inventory drawer and fetch consumables / spare parts / amc for the model
  const openInventory = async () => {
    setInventoryOpen(true);
    setInventoryLoading(true);
    setInventoryData(null);
    setInventoryTab('consumables');
    try {
      const result = await getInventoryByModel({
        technicianId: serviceOrderDetailData?.technician_info?.technician_id,
        country: users?.country || 'ae',
        model_no: serviceOrderDetailData?.product_purchase_details?.model,
      });
      if (result?.code === 100) {
        setInventoryData(result?.data?.items || {});
      } else {
        toast.error(result?.message || 'Failed to load inventory.');
        setInventoryData({});
      }
    } catch (error) {
      toast.error('An error occurred while loading inventory.');
      setInventoryData({});
    } finally {
      setInventoryLoading(false);
    }
  };

  // Open the Make Free Service drawer with a clean form
  const openFreeService = () => {
    setFreeServiceRemark('');
    setFreeServiceAck(false);
    setFreeServiceRemarkError('');
    setFreeServiceAckError('');
    setFreeServiceOpen(true);
  };

  const handleFreeServiceSubmit = async (e) => {
    e.preventDefault();
    setFreeServiceRemarkError('');
    setFreeServiceAckError('');
    let hasError = false;
    if (!freeServiceRemark.trim()) {
      setFreeServiceRemarkError('Please enter a remark.');
      hasError = true;
    }
    if (!freeServiceAck) {
      setFreeServiceAckError('Please confirm to proceed.');
      hasError = true;
    }
    if (hasError) return;
    setIsSubmitting(true);
    try {
      const result = await makeFreeService({
        service_id: serviceOrderDetailData?.service_order_no,
        remarks: freeServiceRemark,
        created_by: users?.user_name,
        user_empid: users?.salesPersonCode || '',
        dispatch,
      });
      if (result?.code === 100) {
        toast.success(result?.message || 'Service marked as free successfully.');
        setFreeServiceOpen(false);
        getServiceOrderDetails({
          params: { service_no: id },
          dispatch,
        });
      } else {
        toast.error(result?.message || 'Failed to mark service as free.');
      }
    } catch (error) {
      toast.error('An error occurred while marking service as free.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOrderUpdateSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const result = await updatePurifierOrder({
        ...orderForm,
        installation_date: orderForm.installation_date ? moment(new Date(orderForm.installation_date)).format('YYYY-MM-DD') : '',
        warranty_end_date: orderForm.warranty_end_date ? moment(new Date(orderForm.warranty_end_date)).format('YYYY-MM-DD') : '',
        amc_start_date: orderForm.amc_start_date ? moment(new Date(orderForm.amc_start_date)).format('YYYY-MM-DD') : '',
        amc_end_date: orderForm.amc_end_date ? moment(new Date(orderForm.amc_end_date)).format('YYYY-MM-DD') : '',
        dispatch,
      });

      if (result?.code === 200) {
        toast.success(result?.message || 'Order details updated successfully.');
        setOrderDetailsOpen(false);
        // Refresh data
        getServiceOrderDetails({
          params: { service_no: id },
          dispatch,
        });
      } else {
        toast.error(result?.message || 'Failed to update order details.');
      }
    } catch (error) {
      toast.error('An error occurred while updating order details.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return <ComplaintShimmer />;
  }

  const items = Array.isArray(serviceOrderDetailData?.items)
    ? serviceOrderDetailData?.items
    : [];

  const isRated = serviceOrderDetailData?.order_details?.isRated;
  const ratingInfo = serviceOrderDetailData?.order_details?.ratingInfo;

  // Rating color: red below 3, yellow at 3, green above 3
  const getRatingColor = (rating) => {
    const r = Number(rating);
    if (r < 3) return '#dc3545';
    if (r === 3) return '#f5b301';
    return '#28a745';
  };

  // Render 5 stars filled up to `rating`, colored by rating band
  const renderStars = (rating, size = '1rem') => {
    const value = Math.round(Number(rating) || 0);
    const color = getRatingColor(rating);
    return [1, 2, 3, 4, 5].map((star) => (
      <i
        key={star}
        className={`mdi ${star <= value ? 'mdi-star' : 'mdi-star-outline'}`}
        style={{ color, fontSize: size }}
      ></i>
    ));
  };

  const feedbackDetails = serviceOrderDetailData?.feedback_details;

  const openLightbox = (idx, imgs) => {
    setLightboxImages(imgs);
    setLightboxIndex(idx);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
    setLightboxImages([]);
  };

  const moveNext = () =>
    setLightboxIndex((lightboxIndex + 1) % lightboxImages.length);
  const movePrev = () =>
    setLightboxIndex(
      (lightboxIndex + lightboxImages.length - 1) % lightboxImages.length,
    );

  // SignatureThumbnail: shows signature image with privacy overlay and eye button

  const SignatureThumbnail = ({ signature, openLightbox }) => {
    const [revealed, setRevealed] = useState(false);
    return (
      <div
        className="bg-white border rounded position-relative d-inline-block"
        style={{
          height: 80,
          minHeight: 80,
          overflow: 'hidden',
          cursor: revealed ? 'pointer' : 'default',
        }}
        onClick={revealed ? openLightbox : undefined}
      >
        <img
          src={signature}
          alt="Customer Signature"
          style={{
            maxHeight: 80,
            maxWidth: 200,
            objectFit: 'contain',
            width: '100%',
            height: '100%',
            filter: revealed ? 'none' : 'blur(2px)',
          }}
        />
        {!revealed && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
            style={{ background: 'rgba(255,255,255,0.7)', zIndex: 2 }}
          >
            <button
              type="button"
              className="btn btn-light d-flex justify-content-center align-items-center shadow-sm"
              style={{
                borderRadius: '50%',
                padding: 10,
                border: '1px solid #ced4da',
              }}
              onClick={(e) => {
                e.stopPropagation();
                setRevealed(true);
              }}
              aria-label="Reveal Signature"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zm-8 4.5c-3.314 0-6.01-2.613-7.021-4.01C1.99 6.613 4.686 4 8 4s6.01 2.613 7.021 4.01C14.01 9.387 11.314 12 8 12zm0-7a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
              </svg>
            </button>
          </div>
        )}
      </div>
    );
  };

  // Open Update Location Offcanvas
  const openUpdateLocation = () => setUpdateLocationOpen(true);
  const closeUpdateLocation = () => setUpdateLocationOpen(false);

  const handleDownloadInvoice = async () => {
    const url = serviceOrderDetailData?.invoice_url;
    if (!url) return;
    setIsDownloadingInvoice(true);
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `Invoice-${serviceOrderDetailData?.service_order_no || id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      // Fallback for cross-origin URLs the browser won't let us fetch directly
      window.open(url, '_blank', 'noopener,noreferrer');
    } finally {
      setIsDownloadingInvoice(false);
    }
  };

  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>{id} | Service Order Detail</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row className="align-items-center">
            <Col>
              <DashBreadcrumb
                title="Service Orders"
                breadcrumbItem={`SR. NO: ${id}`}
              />
            </Col>
              <Col className="d-flex justify-content-end gap-2">
            {Number(serviceOrderDetailData?.is_service_free) === 1 ? (
              <Button color="success" outline disabled>
                <i className="mdi mdi-gift-outline me-1"></i> Free Service
              </Button>
            ) : FREE_SERVICE_ALLOWED_USER_ROLES.includes(
                String(users?.role_id),
              ) &&
              ['New', 'Assigned to Technician'].includes(
                serviceOrderDetailData?.statusInfo?.status_label,
              ) ? (
              <Button color="warning" onClick={openFreeService}>
                <i className="mdi mdi-gift-outline me-1"></i> Make Free Service
              </Button>
            ) : null}
            {serviceOrderDetailData?.is_master_editable === false ? (

                <Button
                  onClick={() =>
                    togglePurchaseDetails(serviceOrderDetailData?.main_order_ref)
                  }
                color="secondary"
                outline
              >
                {isSubmitting ? 'Loading...' : 'View Purchase Details'}
              </Button>
            ) : (
              <Button
                color="dark"
                onClick={toggleOrderDetails}
              >
                Updated Order Details
              </Button>
            )}
            {serviceOrderDetailData?.invoice_url && (
              <Button
                color="primary"
                outline
                onClick={handleDownloadInvoice}
                disabled={isDownloadingInvoice}
              >
                <i className="mdi mdi-file-download-outline me-1"></i>
                {isDownloadingInvoice ? 'Downloading...' : 'Download Invoice'}
              </Button>
            )}
            </Col>
          </Row>

          <Row className="align-items-start border-bottom border-top mb-0 row bg-light border-secondary-subtle">
            <Col md="12" className="border-3 border-end py-4">
              <Row>
                <Col className="d-flex align-items-center justify-content-center">
                  <div className="d-flex flex-column align-items-center">
                    {(() => {
                      const progress = Math.round(
                        Number(serviceOrderDetailData?.progressPercent) || 0,
                      );
                      const progressClass = `progressCircle p${progress}${
                        progress > 50 ? ' over50' : ''
                      }`;
                      return (
                        <div className={progressClass}>
                          <span>{progress}%</span>
                          <div className="leftHalfClipper">
                            <div className="first50Bar"></div>
                            <div className="valueBar"></div>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </Col>
                <Col>
                  <div className="d-flex flex-column gap-2">
                    <h5 className="mb-1 fw-semibold d-flex flex-row gap-2">
                      Service Type{' '}
                      <span
                        className={`badge ${serviceOrderDetailData?.statusInfo?.status_label === 'Canceled' || serviceOrderDetailData?.statusInfo?.status_label === 'Closed' ? 'bg-soft-danger text-danger' : 'bg-soft-success text-dark'} rounded-pill fw-semibold d-flex align-items-center gap-1 p-1`}
                      >
                        <span
                          className={`badge border ${
                            serviceOrderDetailData?.statusInfo?.status_label ===
                            'Canceled' || serviceOrderDetailData?.statusInfo?.status_label === 'Closed'
                              ? 'border-danger text-danger'
                              : 'border-success text-success'
                          } rounded-pill fw-semibold p-0 d-flex flex-column align-items-center justify-content-center`}
                          style={{ width: 12, height: 12 }}
                        >
                          <span
                            className={`badge bg-${
                              serviceOrderDetailData?.statusInfo
                                ?.status_label === 'Canceled' || serviceOrderDetailData?.statusInfo?.status_label === 'Closed'
                                ? 'danger text-danger'
                                : 'success text-success'
                            } rounded-pill fw-semibold d-block p-0`}
                            style={{ width: 6, height: 6 }}
                          ></span>
                        </span>
                        {serviceOrderDetailData?.statusInfo?.status_label}
                      </span>
                    </h5>
                    <p className="m-0 text-capitalize">
                      {serviceOrderDetailData?.service_type?.replace(/_/g, ' ')}
                    </p>
                    {serviceOrderDetailData?.product_purchase_details?.is_amc &&
                      serviceOrderDetailData?.product_purchase_details
                        ?.amc_start_date &&
                      serviceOrderDetailData?.product_purchase_details
                        ?.amc_end_date && (
                        <p className="m-0">
                          AMC Period:{' '}
                          {
                            serviceOrderDetailData?.product_purchase_details?.amc_start_date?.split(
                              ' ',
                            )[0]
                          }{' '}
                          -{' '}
                          {
                            serviceOrderDetailData?.product_purchase_details?.amc_end_date?.split(
                              ' ',
                            )[0]
                          }
                        </p>
                      )}
                    <p className="m-0">
                      Serial No: {serviceOrderDetailData?.product_purchase_details?.serial_no || 'Not Available'}
                    </p>
                    <p className="m-0">
                      Model No:{' '}
                      {serviceOrderDetailData?.product_purchase_details?.model}
                    </p>
                    <p className="text-muted m-0">
                      Created at: {serviceOrderDetailData?.created_at}
                    </p>
                    {Number(serviceOrderDetailData?.feedback_rating) > 0 && (
                      <span
                        role="button"
                        className="d-inline-flex align-items-center mt-1"
                        style={{ cursor: 'pointer' }}
                        title="View feedback rating details"
                        onClick={() => setFeedbackDrawerOpen(true)}
                      >
                        {renderStars(serviceOrderDetailData?.feedback_rating)}
                        <span
                          className="ms-1 fw-semibold"
                          style={{
                            color: getRatingColor(
                              serviceOrderDetailData?.feedback_rating,
                            ),
                          }}
                        >
                          ({serviceOrderDetailData?.feedback_rating})
                        </span>
                      </span>
                    )}
                  </div>
                </Col>
                <Col>
                  <div className="d-flex flex-column gap-2">
                    <h5 className="mb-1 fw-semibold d-flex flex-row gap-2">
                      Customer Details
                    </h5>
                    {serviceOrderDetailData?.customer_info?.customer_name && (
                      <p className="m-0 text-capitalize">
                        {serviceOrderDetailData?.customer_info?.customer_name}
                      </p>
                    )}
                    {serviceOrderDetailData?.customer_info?.email && (
                      <p className="m-0">
                        {serviceOrderDetailData?.customer_info?.email}
                      </p>
                    )}
                    {serviceOrderDetailData?.customer_info?.mobile && (
                      <p className="m-0">
                        Mob: {serviceOrderDetailData?.customer_info?.mobile}
                      </p>
                    )}
                    {serviceOrderDetailData?.customer_info
                      ?.alternate_mobile && (
                      <p className="m-0">
                        Alt No:{' '}
                        {
                          serviceOrderDetailData?.customer_info
                            ?.alternate_mobile
                        }
                      </p>
                    )}
                    {serviceOrderDetailData?.customer_info?.ls_customer_id && (
                      <p className="m-0">
                        LS Customer ID:{' '}
                        {serviceOrderDetailData?.customer_info?.ls_customer_id}
                      </p>
                    )}
                    {(serviceOrderDetailData?.customer_info?.company_name ||
                      serviceOrderDetailData?.customer_info?.trn_no) && (
                      <p className="m-0">
                        {[
                          serviceOrderDetailData?.customer_info?.company_name,
                          serviceOrderDetailData?.customer_info?.trn_no &&
                            `TRN: ${serviceOrderDetailData?.customer_info?.trn_no}`,
                        ]
                          .filter(Boolean)
                          .join(', ')}
                      </p>
                    )}
                    <p className="text-muted m-0 gap-2 d-flex flex-row align-items-center">
                      <Button size="sm" onClick={toggleAddressModal}>
                        View Address
                      </Button>
                      {/* {!serviceOrderDetailData?.customer_info?.latitude && ( */}
                        <>
                          <Button size="sm" onClick={openUpdateLocation}>
                            Update Location
                          </Button>
                          <Button
                            size="sm"
                            onClick={toggleWhatsappConfirmModal}
                          >
                            <i className="mdi mdi-whatsapp me-1"></i> Send
                            WhatsApp
                          </Button>
                        </>
                      {/* )} */}
                    </p>
                  </div>
                </Col>
                {serviceOrderDetailData?.technician_info?.technician_name && (
                  <Col>
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-1 fw-semibold d-flex flex-row gap-2">
                        Technician Details
                      </h5>
                      {serviceOrderDetailData?.technician_info
                        ?.technician_name && (
                        <p className="m-0 text-capitalize">
                          {
                            serviceOrderDetailData?.technician_info
                              ?.technician_name
                          }{' '}
                          {` - (${serviceOrderDetailData?.technician_info?.technician_id})`}
                        </p>
                      )}
                      {serviceOrderDetailData?.technician_info?.email && (
                        <p className="m-0">
                          {serviceOrderDetailData?.technician_info?.email}
                        </p>
                      )}
                      {serviceOrderDetailData?.technician_info?.phone && (
                        <p className="m-0">
                          Mob: {serviceOrderDetailData?.technician_info?.phone}
                        </p>
                      )}
                      {serviceOrderDetailData?.technician_info?.location && (
                        <p className="text-muted m-0">
                          Service Location:{' '}
                          {serviceOrderDetailData?.technician_info?.location}
                        </p>
                      )}
                      <div className="mt-1">
                        <Button size="sm" onClick={openInventory}>
                          <i className="mdi mdi-package-variant-closed me-1"></i>
                          Inventory
                        </Button>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>

          {items && items.length > 0 ? (
            <Row className="px-3 py-4">
              <div className="">
                <h5 className="mb-1 fw-semibold d-flex flex-row gap-2">
                  Service Orders Details
                </h5>
                <p>SO No: {serviceOrderDetailData?.service_order_ls_ref}</p>
              </div>

              {/* Center Panel */}
              <Col md="9" className="border-3">
                <div className="border rounded bg-white">
                  {/* <div className="p-3 border-bottom">
                  <h6 className="fw-bold mb-3">Product Details</h6>
                    <div className="d-flex align-items-center">
                      <div
                        className="bg-light rounded p-1 d-flex align-items-center justify-content-center me-3"
                        style={{ width: '80px', height: '80px' }}
                      >
                        <img
                          src={
                            serviceOrderDetailData?.order_items[0]?.image ||
                            noImage
                          }
                          alt="Product"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">
                          {serviceOrderDetailData?.order_items[0]?.name ||
                            'Product Details'}
                        </h6>
                        <p className="text-muted mb-0 small">
                          Sku:{' '}
                          {serviceOrderDetailData?.order_items[0]?.sku || 'N/A'}
                        </p>
                      </div>
                      <div className="text-end">
                        <div className="d-flex flex-column align-items-end">
                          {serviceOrderDetailData?.order_items[0]?.sku && (
                            <Barcode
                              value={
                                serviceOrderDetailData?.order_items[0]?.sku
                              }
                              height={30}
                              width={1.5}
                              fontSize={12}
                              displayValue={true}
                              margin={0}
                              background="transparent"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                </div> */}

                  <div className="d-flex bg-light p-3 fw-semibold text-muted border-bottom">
                    <div style={{ flex: 7 }}>Serviced Item Details</div>
                    <div style={{ flex: 1 }} className="text-center">
                      Qty
                    </div>
                    <div style={{ flex: 1 }} className="text-end">
                      Price
                    </div>
                    <div style={{ flex: 1 }} className="text-end">
                      Discount
                    </div>
                    <div style={{ flex: 1 }} className="text-end">
                      Total
                    </div>
                  </div>

                  <div className="p-3">
                    {items && items.length > 0 ? (
                      items.map((item, idx) => {
                        const isNonSaleItem = Number(item?.is_non_sale_item) === 1;
                        return (
                        <div
                          key={idx}
                          className={`d-flex flex-wrap align-items-center py-3 px-3 ${
                            isNonSaleItem ? '' : 'border-bottom border-light'
                          }`}
                          style={
                            isNonSaleItem
                              ? {
                                  border: '1px solid #ffc107',
                                  borderRadius: '4px',
                                  marginBottom: '8px',
                                }
                              : undefined
                          }
                        >
                          <div
                            style={{ flex: 7 }}
                            className="d-flex align-items-center"
                          >
                            <div
                              className="bg-light rounded p-1 d-flex align-items-center justify-content-center me-3"
                              style={{ width: '80px', height: '80px' }}
                            >
                              <img
                                src={item?.image || noImage}
                                alt={item.name}
                                style={{
                                  maxWidth: '100%',
                                  maxHeight: '100%',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div>
                              {/* Assuming AMC Service flag exists or logic needed, keeping it static/conditional if data allows */}
                              {item?.is_amc && (
                                <Badge
                                  color="success"
                                  className="mb-1 rounded-0"
                                  style={{ fontSize: '10px' }}
                                >
                                  AMC Service
                                </Badge>
                              )}
                              <h6 className="mb-1">{item.name}</h6>
                              <p className="text-muted mb-0 small">
                                Sku: {item.sku}
                              </p>
                            </div>
                          </div>
                          <div style={{ flex: 1 }} className="text-center">
                            {item.quantity || 1}
                          </div>
                          <div style={{ flex: 1 }} className="text-end">
                            {item.now_price
                              ? `${serviceOrderDetailData?.currency} ${item.now_price * item.quantity}`
                              : '-'}
                          </div>
                          <div style={{ flex: 1 }} className="text-end">
                            {item.discount
                              ? `- ${serviceOrderDetailData?.currency} ${item.discount}`
                              : '-'}
                          </div>
                          <div
                            style={{ flex: 1 }}
                            className="text-end fw-semibold"
                          >
                            {item.total
                              ? `${serviceOrderDetailData?.currency} ${item.total}`
                              : '-'}
                          </div>
                          {isNonSaleItem && item?.non_sale_ls_reference && (
                            <div className="w-100 mt-2 text-secondary" style={{ fontSize: '14px' }}>
                              Non Sale LS Reference: <strong>{item?.non_sale_ls_reference}</strong>
                            </div>
                          )}
                        </div>
                        );
                      })
                    ) : (
                      <div className="text-center p-3 text-muted">
                        No serviced items found
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              {/* Right Panel */}
              <Col md="3">
                <div className="bg-white border rounded p-3 mb-3">
                  <h6 className="fw-bold mb-3 text-uppercase">
                    Invoice Break Up
                  </h6>
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Subtotal</span>
                    <span className="fw-semibold">
                      {serviceOrderDetailData?.currency}{' '}
                      {(
                        Number(serviceOrderDetailData?.sub_total) || 0
                      ).toLocaleString()}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Discount</span>
                    <span className="fw-semibold text-danger">
                      - {serviceOrderDetailData?.currency}{' '}
                      {serviceOrderDetailData?.discount.toLocaleString()}
                    </span>
                  </div>
                  <hr className="my-2" />
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fw-bold">Order Total</span>
                    <span className="fw-bold fs-5">
                      {serviceOrderDetailData?.currency}{' '}
                      {serviceOrderDetailData?.grand_total.toLocaleString()}
                    </span>
                  </div>
                </div>
                <div className="bg-white border rounded p-3">
                  <h6 className="fw-bold mb-3 text-uppercase">
                    Payment Details
                  </h6>
                  <p className="mb-2">
                    <strong>Status:</strong>{' '}
                    {serviceOrderDetailData?.payment_info?.is_paid === '1' ? (
                      <span className="badge bg-soft-success text-success">
                        Paid
                      </span>
                    ) : (
                      <span className="badge bg-soft-danger text-danger">
                        Pending
                      </span>
                    )}
                  </p>
                  <p className="mb-2 text-capitalize">
                    <strong>Payment Provider:</strong>{' '}
                    {serviceOrderDetailData?.payment_info?.payment_mode || ''}
                  </p>
                  {serviceOrderDetailData?.payment_info?.transaction_id && (
                    <p className="mb-3 text-capitalize">
                      <strong>Transaction ID:</strong>{' '}
                      {serviceOrderDetailData?.payment_info?.transaction_id ||
                        ''}
                    </p>
                  )}
                </div>
              </Col>
            </Row>
          ) : (
            <></>
          )}

          <Row className="px-2 py-4 border-top">
            {/* Left Panel */}
            <Col md="3" className="border-2 border-end">
              <div className="p-2">
                <h5 className="fw-semibold mb-4">Service Order Status</h5>

                <div className="ps-3 d-flex flex-column">
                  {serviceOrderDetailData?.statusOrderData?.length > 0 ? (
                    serviceOrderDetailData.statusOrderData.map((step, idx) => {
                      // New structure: step = { stsCode, label, active, created_at }
                      const lastActiveIdx =
                        serviceOrderDetailData.statusOrderData
                          .map((s) => !!s.active)
                          .lastIndexOf(true);
                      const isActive = !!step.active;
                      const isCompleted = idx < lastActiveIdx;
                      const isLast =
                        idx ===
                        serviceOrderDetailData.statusOrderData.length - 1;

                      let iconSrc =
                        'https://assets.danubehome.com/media/assets/svg-v2/tick.svg';
                        
                      const isStatusRed = step.stsCode == 2 || step.stsCode == 3;

                      return (
                        <div key={idx} className="position-relative">
                          <div
                            className={`position-absolute rounded-circle d-flex align-items-center justify-content-center text-white ${isActive ? (isStatusRed ? 'bg-soft-danger' : 'bg-soft-success') : isCompleted ? (isStatusRed ? 'bg-danger' : 'bg-success') : ''}`}
                            style={{
                              width: isActive ? '35px' : '22px',
                              height: isActive ? '35px' : '22px',
                              left: isActive ? '-17px' : '-10px',
                              top: isActive ? '-6px' : '-3px',
                              backgroundColor: isActive
                                ? ''
                                : isCompleted
                                  ? (isStatusRed ? styles.bgRedLight?.backgroundColor : styles.bgGreenLight?.backgroundColor)
                                  : styles.bgGrayLight?.backgroundColor,
                            }}
                          >
                            <div
                              className={`position-absolute rounded-circle d-flex align-items-center justify-content-center text-white ${isActive ? (isStatusRed ? 'bg-danger p-2' : 'bg-success p-2') : isCompleted ? (isStatusRed ? 'bg-danger p-1' : 'bg-success p-1') : 'p-1'}`}
                              style={{
                                backgroundColor:
                                  !isActive && !isCompleted
                                    ? styles.bgGray?.backgroundColor
                                    : undefined,
                              }}
                            >
                              <img
                                src={iconSrc}
                                width={isActive ? '10' : '8'}
                                height={isActive ? '10' : '8'}
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className="ps-4 pb-4"
                            style={
                              isLast
                                ? {}
                                : {
                                    borderLeft: isActive
                                      ? (isStatusRed ? '2px solid #dc3545' : '2px solid #92cc7c') // color for current
                                      : isCompleted
                                        ? (isStatusRed ? '2px solid #dc3545' : '2px solid #13af1bff') // color for previous
                                        : '2px solid #d3d3d3', // gray for others
                                  }
                            }
                          >
                            <strong
                              style={
                                isActive
                                  ? (isStatusRed ? styles.textRed : styles.textGreen)
                                  : isCompleted
                                    ? (isStatusRed ? styles.textRed : styles.textGreenLight)
                                    : styles.textGray
                              }
                            >
                              {step.label}
                            </strong>
                            <p className="mb-0 text-muted small"></p>
                            {step?.created_at && (
                              <small className="text-muted">
                                {`Created on ${moment(
                                  new Date(step?.created_at),
                                ).format('Do MMM, YYYY h:mm:ss A')}`}
                              </small>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </div>

                {
                serviceOrderDetailData?.statusInfo?.status_label ===
                  'Closed' ||
                serviceOrderDetailData?.statusInfo?.status_label ===
                  'Resolved' || 
                serviceOrderDetailData?.statusInfo?.status_label ===
                  'In Progress' ? (
                  <></>
                ) : (
                  <div className="pe-0 pt-4">
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        setStatusError('');
                        setCommentError('');
                        setScheduledDateError('');
                        let hasError = false;
                        if (!selectedStatus) {
                          setStatusError('Please select a status.');
                          hasError = true;
                        }
                        if (selectedStatus === 'Assigned to Technician') {
                          if (!selectedTechnician) {
                            setStatusError('Please select a technician.');
                            hasError = true;
                          }
                          if (!scheduledDate) {
                            setScheduledDateError('Please select a scheduled date.');
                            hasError = true;
                          }
                        }
                        if (!comment.trim()) {
                          setCommentError('Please enter a comment.');
                          hasError = true;
                        }
                        if (hasError) return;
                        setIsSubmitting(true);
                        try {
                          const result = await updateStatus({
                            service_id:
                              serviceOrderDetailData?.service_order_no,
                            status_code: selectedStatus === 'Closed' ? '3' : '2',
                            remarks: comment,
                            created_by: users?.user_name,
                            user_empid: users?.salesPersonCode || '',
                          });

                          if (result?.code === 100) {
                            setStatusError('');
                            setSelectedStatus('');
                            setSelectedTechnician('');
                            setComment('');
                            setScheduledDate('');
                            setCommentError('');
                            setScheduledDateError('');
                            toast.success(selectedStatus === 'Canceled' || selectedStatus === 'Closed' ? 'Status updated successfully.' : 'Technician assigned successfully.');

                            // await getServiceOrderDetails({
                            //   params: {
                            //     service_no:
                            //       serviceOrderDetailData?.service_order_no,
                            //   },
                            //   dispatch,
                            // });

                            setTimeout(() => {
                              window.location.href = `/service-orders/manage-service-orders/`;
                            }, 1000);
                          } else {
                            toast.error(
                              result?.message || 'Failed to update status.',
                            );
                          }
                        } catch (err) {
                          setStatusError('');
                          setCommentError('Failed to update status.');
                        }
                        setIsSubmitting(false);
                      }}
                    >
                      <div className="d-flex flex-wrap gap-3 w-100">
                        <FormGroup className="w-100">
                          <Label>Select Status*</Label>
                          <select
                            className="form-control form-select "
                            id="choices-single-no-search"
                            value={selectedStatus}
                            onChange={(e) =>
                              setSelectedStatus(e.target.value)
                            }
                            disabled={isSubmitting}
                          >
                            <option value="" hidden selected>
                              Select
                            </option>
                            <option value="Assigned to Technician">Assigned to Technician</option>
                            {serviceOrderDetailData?.statusInfo?.status_label !== 'Canceled' && (
                              <option value="Canceled">Canceled</option>
                            )}
                            {serviceOrderDetailData?.statusInfo?.status_label === 'Canceled' && (
                              <option value="Closed">Closed</option>
                            )}
                          </select>
                          
                          {statusError === 'Please select a status.' && (
                            <div style={{ color: 'red', marginTop: '5px' }}>
                              {statusError}
                            </div>
                          )}
                        </FormGroup>
                        {(selectedStatus === 'Canceled' || selectedStatus === 'Closed') && (
                          <>
                        <FormGroup className="w-100">
                          <Label>Comment*</Label>
                          <TextArea
                            className="form-control form-textArea"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            disabled={isSubmitting}
                          ></TextArea>
                          {commentError && (
                            <div style={{ color: 'red', marginTop: '5px' }}>
                              {commentError}
                            </div>
                          )}
                        </FormGroup>
                        
                        <Button
                          color="success"
                          size="md"
                          className="ms-auto"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Submitting...' : 'Submit'}
                        </Button>
                        </>
                        )}
                      </div>
                    </form>
                  </div>
                )}

                {(serviceOrderDetailData?.statusInfo?.status_label ===
                  'New' || 
                  serviceOrderDetailData?.statusInfo?.status_label ===
                  'Pending' || 
                  serviceOrderDetailData?.statusInfo?.status_label ===
                  'In Progress' || 
                  serviceOrderDetailData?.statusInfo?.status_label ===
                  'Rescheduled' ||serviceOrderDetailData?.statusInfo?.status_label ===
                  'Assigned to Technician' ||serviceOrderDetailData?.statusInfo?.status_label ===
                  'Canceled')
                  &&
                selectedStatus ===
                  'Assigned to Technician' ? (
                  <>
                  <div className="pe-0 pt-4">
                    <h4>Assigned to</h4>
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        setStatusError('');
                        setCommentError('');
                        setScheduledDateError('');
                        let hasError = false;
                        if (!selectedTechnician) {
                          setStatusError('Please select a technician.');
                          hasError = true;
                        }
                        if (!scheduledDate) {
                          setScheduledDateError(
                            'Please select a scheduled date.',
                          );
                          hasError = true;
                        }
                        if (!comment.trim()) {
                          setCommentError('Please enter a comment.');
                          hasError = true;
                        }
                        if (hasError) return;
                        setIsSubmitting(true);
                        try {
                          const result = await assignToTechnician({
                            service_no:
                              serviceOrderDetailData?.service_order_no,
                            technician_id:
                              typeof selectedTechnician === 'object'
                                ? selectedTechnician.value
                                : selectedTechnician,
                            comment: comment,
                            scheduled_date: scheduledDate
                              ? moment(scheduledDate[0]).format('YYYY-MM-DD')
                              : '',
                            created_by: users?.user_name,
                            user_empid: users?.salesPersonCode || '',
                            dispatch,
                          });

                          if (result?.code === 100) {
                            setStatusError('');
                            setSelectedTechnician('');
                            setComment('');
                            setScheduledDate('');
                            setCommentError('');
                            setScheduledDateError('');
                            toast.success('Technician assigned successfully.');

                            // await getServiceOrderDetails({
                            //   params: {
                            //     service_no:
                            //       serviceOrderDetailData?.service_order_no,
                            //   },
                            //   dispatch,
                            // });

                            setTimeout(() => {
                              window.location.href = `/service-orders/manage-service-orders/`;
                            }, 1000);
                          } else {
                            toast.error(
                              result?.message || 'Failed to assign technician.',
                            );
                          }
                        } catch (err) {
                          setStatusError('');
                          setCommentError('Failed to assign technician.');
                        }
                        setIsSubmitting(false);
                      }}
                    >
                      <div className="d-flex flex-wrap gap-3 w-100">
                        <FormGroup className="w-100">
                          <Label>Technician*</Label>
                          <select
                            className="form-control form-select "
                            id="choices-single-no-search"
                            value={selectedTechnician}
                            onChange={(e) =>
                              setSelectedTechnician(e.target.value)
                            }
                            disabled={isSubmitting}
                          >
                            <option value="" hidden selected>
                              Select
                            </option>
                            {technicians.map((option, idx) => (
                              <option key={idx} value={option?.emp_id}>
                                {`${option?.email} - Jobs(${option?.job_count})`}
                              </option>
                            ))}
                          </select>
                          {selectedTechnician && (
                            <>
                              {technicians
                                ?.filter(
                                  (option) =>
                                    option?.emp_id === selectedTechnician,
                                )
                                .map((option, idx) => (
                                  <div key={idx} className="mt-2 text-danger">
                                    Total Assigned Today:{' '}
                                    {option?.job_count || 0}
                                  </div>
                                ))}
                            </>
                          )}
                          {statusError && (
                            <div style={{ color: 'red', marginTop: '5px' }}>
                              {statusError}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup className="w-100">
                          <Label>Scheduled Date*</Label>
                          <Flatpickr
                            className="form-control d-block"
                            placeholder="Select Date"
                            options={{
                              enableTime: false,
                              noCalendar: false,
                              altInput: true,
                              altFormat: 'F j, Y',
                              dateFormat: 'Y-m-d',
                              time_24hr: false,
                              minDate: moment()
                                .startOf('day')
                                .toDate(),
                              minuteIncrement: 15,
                            }}
                            value={scheduledDate}
                            onChange={(date) => setScheduledDate(date)}
                          />
                          {scheduledDateError && (
                            <div style={{ color: 'red', marginTop: '5px' }}>
                              {scheduledDateError}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup className="w-100">
                          <Label>Comment*</Label>
                          <TextArea
                            className="form-control form-textArea"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            disabled={isSubmitting}
                          ></TextArea>
                          {commentError && (
                            <div style={{ color: 'red', marginTop: '5px' }}>
                              {commentError}
                            </div>
                          )}
                        </FormGroup>
                        <Button
                          color="success"
                          size="md"
                          className="ms-auto"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Submitting...' : 'Submit'}
                        </Button>
                      </div>
                    </form>
                  </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Col>

            {/* Center Panel */}
            <Col md="9" className="border-3">
              <div className="p-2">
                {/* <div className="bg-soft-light p-4 rounded-3 mb-4 border">
                  <div className="d-flex flex-row align-items-center gap-3 pb-2">
                    <div>
                      <h5>Created New Service Request</h5>
                      <p className="text-muted">
                        on {serviceOrderDetailData?.order_details?.created_at}
                      </p>
                      {serviceOrderDetailData?.complaintRemark && (
                      <p>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: serviceOrderDetailData.complaintRemark.replace(/\n/g, '<br />')
                          }}
                        />
                    </p>
                      )}

                    </div>
                  </div>
                      {images.length > 0 ? (
                        <>
                    <h6 className="fw-semibold mb-3">Uploaded Images</h6>
                    <div className="d-flex flex-wrap gap-2">
                        {images.map((imgUrl, idx) => (
                          <div
                            key={idx}
                            className="bg-light border border-1 border-secondary-subtle rounded"
                            style={{
                              width: '85px',
                              height: '85px',
                            }}
                          >
                            <img
                              src={imgUrl}
                              className='rounded'
                              width={83}
                              height={83}
                              alt={`Uploaded ${idx + 1}`}
                              style={{ cursor: 'pointer' }}
                              onClick={() => openLightbox(idx)}
                            />
                          </div>
                        ))}
                    </div>
                    </>
                      ) : (
                        <></>
                      )}
                      {isLightboxOpen && (
                        <Lightbox
                          mainSrc={images[lightboxIndex]}
                          nextSrc={images[(lightboxIndex + 1) % images.length]}
                          prevSrc={images[(lightboxIndex + images.length - 1) % images.length]}
                          onCloseRequest={closeLightbox}
                          onMovePrevRequest={movePrev}
                          onMoveNextRequest={moveNext}
                          imageTitle={`Uploaded ${lightboxIndex + 1}`}
                        />
                      )}
                </div> */}

                {serviceOrderDetailData?.customer_comment && (
                  <div
                    className="p-4 rounded-3 mb-4"
                    style={{
                      backgroundColor: '#fff9e6',
                      border: '1px solid #ffeeba',
                    }}
                  >
                    <h6 className="fw-semibold mb-2">Customer Comment</h6>
                    <p className="mb-0">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: serviceOrderDetailData.customer_comment.replace(
                            /\n/g,
                            '<br />',
                          ),
                        }}
                      />
                    </p>
                  </div>
                )}

                {serviceOrderDetailData?.serviceHistory?.length > 0 ? (
                  serviceOrderDetailData.serviceHistory.map((step, idx) => {
                    const isResolved =
                      step?.status_text?.toLowerCase() === 'resolved';
                    const isAssigned =
                      step?.status_text?.toLowerCase() ===
                        'assigned to technician' ||
                      step?.status_text?.toLowerCase() === 'rescheduled';
                    const isCanceled =
                      step?.status_text?.toLowerCase() === 'canceled';
                    const isClosed =
                      step?.status_text?.toLowerCase() === 'closed';
                    const isRescheduled =
                      step?.status_text?.toLowerCase() === 'rescheduled';
                    const isNew = step?.status_text?.toLowerCase() === 'new';
                    return (
                      <div key={idx}>
                        {step?.remark && (
                          <div
                            className="p-4 rounded-3 mb-4"
                            style={{
                              backgroundColor: isResolved
                                ? '#f9fdf7'
                                : isCanceled || isClosed
                                  ? '#fff5f5'
                                  : isRescheduled
                                    ? '#fff9e6'
                                    : '#f8f9fa',
                              border: isResolved
                                ? '1px solid #6ea34f'
                                : isCanceled || isClosed
                                  ? '1px solid #fecaca'
                                  : isRescheduled
                                    ? '1px solid #ffeeba'
                                    : '1px solid #f8f9fa',
                            }}
                          >
                            <div className="d-flex flex-row align-items-center gap-3">
                              <div>
                                <h6 className="text-capitalize">
                                  {step?.status_text?.toLowerCase() === 'new'
                                    ? 'Created New Service Request'
                                    : step?.status_text?.toLowerCase() ===
                                        'resolved'
                                      ? 'Service Completed'
                                      : step?.status_text?.toLowerCase() ===
                                            'scheduled request' ||
                                          step?.status_text?.toLowerCase() ===
                                            'assigned to technician'
                                        ? 'Service Scheduled'
                                        : step?.status_text?.toLowerCase() ===
                                            'in progress'
                                          ? 'Service In Progress'
                                          : step?.status_text?.toLowerCase() ===
                                              'canceled'
                                            ? 'Service Canceled'
                                            : step?.status_text?.toLowerCase() ===
                                                'rescheduled'
                                              ? 'Service Rescheduled'
                                              : step?.status_text}
                                  <span className="text-muted fs-6">
                                    {' '}
                                    - by {step?.created_by}
                                  </span>
                                </h6>
                                <p className="text-muted">
                                  on {step?.created_at}
                                </p>
                                <p>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: step?.remark.replace(
                                        /\n/g,
                                        '<br />',
                                      ),
                                    }}
                                  />
                                </p>
                              </div>
                            </div>

                            {
                              step?.assigned_to && (
                                <div className="d-flex flex-wrap gap-2">
                                  <div className="d-flex align-items-center gap-2 border rounded-3 p-2 bg-white">
                                    <div
                                      className="bg-light rounded p-2 d-flex align-items-center justify-content-center"
                                      style={{ width: '38px', height: '38px' }}
                                    >
                                      <i className="mdi mdi-calendar-clock text-black fs-4"></i>
                                    </div>
                                    <div>
                                      <p className="text-muted mb-0 small fw-medium">
                                        Scheduled On
                                      </p>
                                      <h6 className="mb-0 fw-bold">
                                        {moment(
                                          step
                                            .scheduled_at,
                                        ).isValid()
                                          ? moment(
                                              step
                                                .scheduled_at,
                                            ).format('D MMM YYYY')
                                          : step
                                              .scheduled_at}
                                      </h6>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center gap-2 border rounded-3 p-2 bg-white">
                                    <div
                                      className="bg-light rounded p-2 d-flex align-items-center justify-content-center"
                                      style={{ width: '38px', height: '38px' }}
                                    >
                                      <i className="mdi mdi-account-cog text-black fs-4"></i>
                                    </div>
                                    <div>
                                      <p className="text-muted mb-0 small fw-medium">
                                        Assigned to Technician
                                      </p>
                                      <h6 className="mb-0 fw-bold text-capitalize">
                                        {step
                                          ?.technician_name || 'N/A'}{' '}
                                        {step?.assigned_to
                                          ? `(${step?.assigned_to})`
                                          : ''}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              )}

                            {/* {isResolved &&
                              (items?.length > 0 ||
                                step?.service_charges?.length > 0) && (
                                <div className="d-flex flex-wrap gap-2 mb-3">
                                  {(items || step?.service_charges).map(
                                    (item, iIdx) => (
                                      <div
                                        key={iIdx}
                                        className="border border-secondary-subtle rounded-3 p-1 px-3 bg-white fw-medium small d-flex align-items-center gap-1 shadow-sm"
                                        style={{ border: '1px solid #ced4da' }}
                                      >
                                        <span>
                                          {item.label ||
                                            item.name ||
                                            item.item_name}
                                        </span>
                                        <span className="text-muted mx-1">
                                          -
                                        </span>
                                        <span className="fw-bold">
                                          {serviceOrderDetailData?.currency}{' '}
                                          {item.amount ||
                                            item.price ||
                                            item.total ||
                                            0}
                                        </span>
                                      </div>
                                    ),
                                  )}
                                </div>
                              )} */}

                            {isNew && (
                              <div className="d-flex justify-content-between align-items-end">
                                <div>
                                  {serviceOrderDetailData?.user_images?.length >
                                    0 && (
                                    <>
                                      <h6 className="fw-semibold mb-3">
                                        Uploaded Images
                                      </h6>
                                      <div className="d-flex flex-wrap gap-2">
                                        {serviceOrderDetailData?.user_images?.map(
                                          (imgUrl, imgIdx) => (
                                            <div
                                              key={imgIdx}
                                              className="bg-light border border-1 border-secondary-subtle rounded"
                                              style={{
                                                width: '85px',
                                                height: '85px',
                                              }}
                                            >
                                              <img
                                                src={imgUrl}
                                                className="rounded"
                                                width={83}
                                                height={83}
                                                alt={`Uploaded ${imgIdx + 1}`}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                  openLightbox(imgIdx, [
                                                    serviceOrderDetailData.user_images,
                                                  ])
                                                }
                                              />
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            )}

                            {isResolved &&
                              (serviceOrderDetailData?.uploaded_images?.length > 0 ||
                                serviceOrderDetailData?.amc_contract_image?.length > 0) && (
                                <div className="d-flex justify-content-between align-items-end">
                                  <div>
                                    {serviceOrderDetailData?.uploaded_images
                                      ?.length > 0 && (
                                      <>
                                        <h6 className="fw-semibold mb-3">
                                          Uploaded Images
                                        </h6>
                                        <div className="d-flex flex-wrap gap-2">
                                          {serviceOrderDetailData?.uploaded_images?.map(
                                            (imgUrl, imgIdx) => (
                                              <div
                                                key={imgIdx}
                                                className="bg-light border border-1 border-secondary-subtle rounded"
                                                style={{
                                                  width: '85px',
                                                  height: '85px',
                                                }}
                                              >
                                                <img
                                                  src={imgUrl}
                                                  className="rounded"
                                                  width={83}
                                                  height={83}
                                                  alt={`Uploaded ${imgIdx + 1}`}
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() =>
                                                    openLightbox(
                                                      imgIdx,
                                                      serviceOrderDetailData.uploaded_images,
                                                    )
                                                  }
                                                />
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </div>

                                  {serviceOrderDetailData?.amc_contract_image?.length > 0 && (
                                    <div>
                                      <h6 className="fw-semibold mb-3">
                                        AMC Contract Images
                                      </h6>
                                      <div className="d-flex flex-wrap gap-2">
                                        {serviceOrderDetailData?.amc_contract_image?.map(
                                          (imgUrl, imgIdx) => (
                                            <div
                                              key={imgIdx}
                                              className="bg-light border border-1 border-secondary-subtle rounded"
                                              style={{
                                                width: '85px',
                                                height: '85px',
                                              }}
                                            >
                                              <img
                                                src={imgUrl}
                                                className="rounded"
                                                width={83}
                                                height={83}
                                                alt={`AMC Contract ${imgIdx + 1}`}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                  openLightbox(
                                                    imgIdx,
                                                    serviceOrderDetailData.amc_contract_image,
                                                  )
                                                }
                                              />
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div>
                                    {serviceOrderDetailData
                                      ?.product_purchase_details
                                      ?.serial_no_image?.length > 0 && (
                                      <>
                                        <h6 className="fw-semibold mb-3">
                                          Serial Number Details
                                        </h6>
                                        <div className="d-flex flex-wrap gap-2">
                                          {serviceOrderDetailData?.product_purchase_details?.serial_no_image?.map(
                                            (imgUrl, imgIdx) => (
                                              <div
                                                key={imgIdx}
                                                className="bg-white border rounded d-flex align-items-center"
                                                style={{
                                                  minWidth: '250px',
                                                  minHeight: '85px',
                                                  maxWidth: '550px',
                                                }}
                                              >
                                                <div
                                                  className="me-2 d-flex align-items-center justify-content-center"
                                                  style={{
                                                    width: '85px',
                                                    height: '85px',
                                                  }}
                                                >
                                                  <img
                                                    src={imgUrl}
                                                    className="rounded"
                                                    width={83}
                                                    height={83}
                                                    alt={`Uploaded ${imgIdx + 1}`}
                                                    style={{
                                                      cursor: 'pointer',
                                                      objectFit: 'cover',
                                                      width: '83px',
                                                      height: '83px',
                                                    }}
                                                    onClick={() =>
                                                      openLightbox(
                                                        imgIdx,
                                                        serviceOrderDetailData
                                                          ?.product_purchase_details
                                                          ?.serial_no_image,
                                                      )
                                                    }
                                                  />
                                                </div>
                                                {serviceOrderDetailData
                                                  ?.product_purchase_details
                                                  ?.serial_no && (
                                                  <div className="flex-grow-1 text-start ps-2">
                                                    <span className="text-muted small fw-semibold">
                                                      Serial No:
                                                    </span>
                                                    <div
                                                      className="fw-bold text-dark"
                                                      style={{
                                                        wordBreak: 'break-all',
                                                      }}
                                                    >
                                                      {
                                                        serviceOrderDetailData
                                                          ?.product_purchase_details
                                                          ?.serial_no
                                                      }
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </div>

                                  {isResolved &&
                                    serviceOrderDetailData?.signature?.length >
                                      0 && (
                                      <div
                                        className="text-end position-relative"
                                        style={{ display: 'inline-block' }}
                                      >
                                        <h6 className="fw-semibold mb-2 text-dark">
                                          Customer Signature
                                        </h6>
                                        <SignatureThumbnail
                                          signature={
                                            serviceOrderDetailData.signature
                                          }
                                          openLightbox={() =>
                                            openLightbox(0, [
                                              serviceOrderDetailData.signature,
                                            ])
                                          }
                                        />
                                      </div>
                                    )}
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <></>
                )}
                {isLightboxOpen && lightboxImages.length > 0 && (
                  <Lightbox
                    mainSrc={lightboxImages[lightboxIndex]}
                    nextSrc={
                      lightboxImages[
                        (lightboxIndex + 1) % lightboxImages.length
                      ]
                    }
                    prevSrc={
                      lightboxImages[
                        (lightboxIndex + lightboxImages.length - 1) %
                          lightboxImages.length
                      ]
                    }
                    onCloseRequest={closeLightbox}
                    onMovePrevRequest={movePrev}
                    onMoveNextRequest={moveNext}
                    imageTitle={`Preview ${lightboxIndex + 1}`}
                  />
                )}

                {serviceOrderDetailData?.rating?.length > 0 && (
                  <div className="bg-white p-4 rounded-3 mb-4 border shadow-sm">
                    {(() => {
                      const rate = serviceOrderDetailData.rating[0];
                      return (
                        <>
                          <div className="d-flex flex-column gap-1 mb-3">
                            <h6 className="fw-bold mb-0">Customer Feedback</h6>
                            <p className="text-muted small mb-0">
                              On {rate?.created_at}
                            </p>
                          </div>

                          <div className="d-flex align-items-center gap-2 mb-3">
                            <div className="text-warning d-flex">
                              {[1, 2, 3, 4, 5].map((star) => {
                                const rValue = Number(rate?.rating) || 0;
                                return (
                                  <i
                                    key={star}
                                    className={`mdi ${
                                      rValue >= star
                                        ? 'mdi-star'
                                        : rValue >= star - 0.5
                                          ? 'mdi-star-half-full'
                                          : 'mdi-star-outline'
                                    } fs-3`}
                                  ></i>
                                );
                              })}
                            </div>
                            <h3 className="mb-0 fw-bold ms-1 text-dark">
                              {Number(rate?.rating || 0).toFixed(1)}
                            </h3>
                          </div>

                          {rate?.remark && (
                            <p
                              className="mb-0 text-dark"
                              style={{ fontSize: '0.95rem', lineHeight: '1.6' }}
                            >
                              {rate?.remark}
                            </p>
                          )}
                        </>
                      );
                    })()}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <Modal
            isOpen={addressModal}
            toggle={toggleAddressModal}
            centered
            size="md"
          >
            <ModalHeader toggle={toggleAddressModal} tag="h4">
              Customer Details
            </ModalHeader>
            <ModalBody>
              <div className="mb-3">
                <div className="rounded overflow-hidden border position-relative">
                  <div className="position-absolute top-0 end-0 m-2" style={{ zIndex: 1 }}>
                    <Button
                      color="white"
                      size="sm"
                      className="shadow-sm border border-secondary-subtle d-flex align-items-center gap-2"
                      style={{ borderRadius: '30px', padding: '5px 15px', backgroundColor: '#ffffff' }}
                      onClick={() => {
                        const lat = serviceOrderDetailData?.customer_info?.latitude;
                        const lng = serviceOrderDetailData?.customer_info?.longitude;
                        if (lat && lng) {
                          window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank');
                        }
                      }}
                    >
                      <i className="mdi mdi-directions text-primary fs-5"></i>
                      <span className="fw-bold text-dark">Get Direction</span>
                    </Button>
                  </div>
                  <GoogleMaps
                    readOnly={true}
                    center={{
                      lat: Number(
                        serviceOrderDetailData?.customer_info?.latitude,
                      ),
                      lng: Number(
                        serviceOrderDetailData?.customer_info?.longitude,
                      ),
                    }}
                    showMarkerAtCenter={true}
                    zoom={17}
                    containerStyle={{ width: '100%', height: '300px' }}
                  />
                </div>
              </div>
              <div>
                <h5 className="font-size-15 mb-1 text-capitalize">
                  {serviceOrderDetailData?.customer_info?.customer_name}
                </h5>
                <p className="text-muted mb-1">
                  {serviceOrderDetailData?.customer_info?.email}
                </p>
                <p className="text-muted mb-1">
                  Mob : {serviceOrderDetailData?.customer_info?.mobile}
                  {serviceOrderDetailData?.customer_info?.alternate_mobile &&
                    `, Alt No : ${serviceOrderDetailData?.customer_info?.alternate_mobile}`}
                </p>
                <p className="text-muted mb-3">
                  LS Customer ID :{' '}
                  {serviceOrderDetailData?.customer_info?.ls_customer_id ||
                    '0000000000'}
                </p>

                <p className="mb-0 text-muted text-capitalize">
                  {' '}
                  <strong className="text-dark">Address : </strong>{' '}
                  {`${serviceOrderDetailData?.customer_info?.address1}, ${serviceOrderDetailData?.customer_info?.address2}, ${serviceOrderDetailData?.customer_info?.emirate}` ||
                    'Address information not available'}{' '}
                </p>

                {(serviceOrderDetailData?.customer_info?.company_name ||
                  serviceOrderDetailData?.customer_info?.trn_no) && (
                  <p className="mb-0 text-muted mt-1">
                    <strong className="text-dark">Company Info : </strong>{' '}
                    {[
                      serviceOrderDetailData?.customer_info?.company_name,
                      serviceOrderDetailData?.customer_info?.trn_no &&
                        `TRN: ${serviceOrderDetailData?.customer_info?.trn_no}`,
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </p>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                outline
                onClick={toggleAddressModal}
                style={{ minWidth: '100px' }}
              >
                CLOSE
              </Button>
            </ModalFooter>
          </Modal>

          <Offcanvas
            isOpen={purchaseDetailsOpen}
            toggle={setPurchaseDetailsOpen}
            direction="end"
            style={{ width: '550px', backgroundColor: '#ffffff' }}
          >
            <div className="p-4 border-bottom bg-white sticky-top shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="bg-primary bg-opacity-10 p-2 rounded-3">
                    <i className="mdi mdi-shopping-outline text-primary fs-4"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0 text-dark">Purchase Details</h5>
                    <p className="text-muted small mb-0">View product and warranty information</p>
                  </div>
                </div>
                <Button
                  type="button"
                  className="btn-close"
                  onClick={() => setPurchaseDetailsOpen(false)}
                  aria-label="Close"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                ></Button>
              </div>
            </div>
            
            <OffcanvasBody className="p-0">
              <div className="p-4">
                {serviceOrderPurchaseDetailData &&
                serviceOrderPurchaseDetailData.length > 0 ? (
                  serviceOrderPurchaseDetailData.map((item, idx) => (
                    <div 
                      key={idx} 
                      className="card border mb-4 shadow-sm overflow-hidden"
                      style={{ borderRadius: '12px', borderColor: '#edf2f7', backgroundColor: '#ffffff' }}
                    >
                      <div className="card-body p-0">
                        {/* Compact Product Header */}
                        {/* <div className="px-3 py-3 border-bottom">
                          <h6
                            className="fw-bold text-dark mb-0"
                            style={{ 
                              fontSize: '0.95rem', 
                              lineHeight: '1.4',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                            }}
                          >
                            {item?.product_name}
                          </h6>
                        </div> */}

                        <div className="p-3">
                          <Row className="g-3 align-items-center">
                            <Col xs="3">
                              <div
                                className="bg-white rounded d-flex align-items-center justify-content-center border"
                                style={{ height: '80px', width: '80px', padding: '5px' }}
                              >
                                <img
                                  src={item.product_image || noImage}
                                  alt={item.product_name}
                                  className="img-fluid"
                                  style={{
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                  }}
                                />
                              </div>
                            </Col>
                            <Col xs="9">
                              <div className="specs-grid">
                                <Row className="g-2">
                                  {[
                                    { label: 'SO NUMBER', value: item?.so_no, icon: 'mdi-tag-outline' },
                                    { label: 'SKU', value: item?.item_code, icon: 'mdi-barcode-scan' },
                                    { label: 'MODEL NO', value: item?.model_no, icon: 'mdi-cube-outline' },
                                    { label: 'SERIAL NO', value: item?.serial_no, icon: 'mdi-numeric' },
                                  ].map((spec, sIdx) => (
                                    <Col xs="6" key={sIdx}>
                                      <div className="overflow-hidden mb-2">
                                        <div className="d-flex align-items-center gap-1 mb-0">
                                          <i className={`mdi ${spec.icon} text-muted`} style={{ fontSize: '0.9rem' }}></i>
                                          <p className="mb-0 text-muted" style={{ fontSize: '0.6rem', fontWeight: '500', letterSpacing: '0.3px' }}>{spec.label}</p>
                                        </div>
                                        <p className="mb-0 fw-semibold text-dark text-truncate ms-3 ps-1" style={{ fontSize: '0.75rem' }}>
                                          {spec.value || '-'}
                                        </p>
                                      </div>
                                    </Col>
                                  ))}
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        
                        {/* Status Section - Minimalist */}
                        <div className="px-3 pb-3">
                          <div className="p-3 rounded-3 border" style={{ backgroundColor: '#fcfcfd' }}>
                            <Row className="g-3">
                              <Col xs="6">
                                <div className="border-end pe-3 h-100">
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <i className="mdi mdi-shield-check-outline text-muted" style={{ fontSize: '0.85rem' }}></i>
                                    <span className="text-muted fw-bold" style={{ fontSize: '0.65rem' }}>WARRANTY</span>
                                  </div>
                                  <p className="mb-0 fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{item?.warranty || 0} Months</p>
                                  <p className="mb-0 text-muted" style={{ fontSize: '0.65rem' }}>
                                    Ends <span className="text-danger fw-medium">{item?.warranty_end_date || 'N/A'}</span>
                                  </p>
                                </div>
                              </Col>
                              <Col xs="6">
                                <div className="ps-2">
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <i className="mdi mdi-calendar-check text-muted" style={{ fontSize: '0.85rem' }}></i>
                                    <span className="text-muted fw-bold" style={{ fontSize: '0.65rem' }}>INSTALLATION</span>
                                  </div>
                                  <p className="mb-0 fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{item?.installation_date || 'N/A'}</p>
                                  <p className="mb-0 text-muted" style={{ fontSize: '0.65rem' }}>Successfully installed</p>
                                </div>
                              </Col>
                            </Row>

                            {(item?.amc_start_date || item?.amc_end_date) && (
                              <div className="mt-3 pt-2 border-top">
                                <div className="d-flex align-items-center gap-2">
                                  <div className="bg-success rounded-circle" style={{ width: '8px', height: '8px' }}></div>
                                  <span className="text-success fw-bold" style={{ fontSize: '0.7rem' }}>AMC ACTIVE</span>
                                </div>
                                <p className="mb-0 text-muted mt-1" style={{ fontSize: '0.7rem' }}>
                                  Service covered from <span className="fw-semibold">{item?.amc_start_date}</span> to <span className="fw-semibold">{item?.amc_end_date}</span>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5">
                    <div className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                      <i className="mdi mdi-package-variant text-muted" style={{ fontSize: '2.5rem' }}></i>
                    </div>
                    <h6 className="text-dark fw-bold">No Purchase Details</h6>
                    <p className="text-muted small">We couldn't find any purchase information for this order.</p>
                  </div>
                )}
              </div>
            </OffcanvasBody>
          </Offcanvas>

          {/* Offcanvas for Technician Inventory */}
          <Offcanvas
            isOpen={inventoryOpen}
            toggle={() => setInventoryOpen(false)}
            direction="end"
            style={{ width: '550px', backgroundColor: '#ffffff' }}
          >
            <div className="p-4 border-bottom bg-white sticky-top shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="bg-primary bg-opacity-10 p-2 rounded-3">
                    <i className="mdi mdi-package-variant-closed text-primary fs-4"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0 text-dark">Inventory</h5>
                    <p className="text-muted small mb-0">
                      Model: {serviceOrderDetailData?.product_purchase_details?.model || '-'}
                    </p>
                  </div>
                </div>
                <Button
                  type="button"
                  className="btn-close"
                  onClick={() => setInventoryOpen(false)}
                  aria-label="Close"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                ></Button>
              </div>
            </div>

            <OffcanvasBody className="p-0">
              {inventoryLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-muted small mt-3 mb-0">Loading inventory...</p>
                </div>
              ) : (
                <>
                  {/* Tabs */}
                  {(() => {
                    const tabs = [
                      { key: 'consumables', label: 'Consumables', dataKey: 'consumables' },
                      { key: 'spare_parts', label: 'Spare Parts', dataKey: 'spare_parts' },
                      { key: 'service', label: 'Service', dataKey: 'service' },
                      { key: 'amc', label: 'AMC', dataKey: 'amc' },
                    ];
                    return (
                      <ul className="nav nav-tabs nav-justified px-3 pt-3" role="tablist">
                        {tabs.map((tab) => {
                          const count = Array.isArray(inventoryData?.[tab.dataKey])
                            ? inventoryData[tab.dataKey].length
                            : 0;
                          return (
                            <li className="nav-item" key={tab.key}>
                              <button
                                type="button"
                                className={`nav-link w-100 text-nowrap px-2 ${inventoryTab === tab.key ? 'active' : ''}`}
                                style={{ fontSize: '0.75rem' }}
                                onClick={() => setInventoryTab(tab.key)}
                              >
                                {tab.label} ({count})
                              </button>
                            </li>
                          );
                        })}
                      </ul>
                    );
                  })()}

                  <div className="p-3">
                    {/* AMC tab (grouped packages) */}
                    {inventoryTab === 'amc' ? (
                      Array.isArray(inventoryData?.amc) && inventoryData.amc.length > 0 ? (
                        inventoryData.amc.map((amc, idx) => (
                          <div
                            key={idx}
                            className="card border mb-3 shadow-sm overflow-hidden"
                            style={{ borderRadius: '12px', borderColor: '#edf2f7' }}
                          >
                            <div className="card-body p-3">
                              <div
                                className="d-flex justify-content-between align-items-start"
                                style={{
                                  cursor:
                                    Array.isArray(amc?.amcItems) && amc.amcItems.length > 0
                                      ? 'pointer'
                                      : 'default',
                                }}
                                onClick={() =>
                                  Array.isArray(amc?.amcItems) &&
                                  amc.amcItems.length > 0 &&
                                  toggleAmcItems(idx)
                                }
                              >
                                <div>
                                  <h6 className="fw-bold mb-1">
                                    {Array.isArray(amc?.amcItems) && amc.amcItems.length > 0 && (
                                      <i
                                        className={`mdi ${expandedAmc[idx] ? 'mdi-chevron-down' : 'mdi-chevron-right'} me-1`}
                                      ></i>
                                    )}
                                    {amc?.title}
                                  </h6>
                                  <p className="text-muted small mb-0">Sku: {amc?.sku}</p>
                                </div>
                                <span className="fw-bold text-dark text-nowrap ms-2">
                                  {serviceOrderDetailData?.currency} {amc?.price}
                                </span>
                              </div>
                              {expandedAmc[idx] &&
                                Array.isArray(amc?.amcItems) &&
                                amc.amcItems.length > 0 && (
                                <div className="mt-3 pt-2 border-top">
                                  {amc.amcItems.map((sub, sIdx) => (
                                    <div
                                      key={sIdx}
                                      className="d-flex justify-content-between align-items-center py-1"
                                    >
                                      <div className="me-2">
                                        <p className="mb-0 small fw-medium">{sub?.title}</p>
                                        <p className="mb-0 text-muted" style={{ fontSize: '0.7rem' }}>
                                          {sub?.sku} · {sub?.product_type} · Qty: {sub?.qty}
                                        </p>
                                      </div>
                                      <span className="small text-nowrap">
                                        {serviceOrderDetailData?.currency} {sub?.price}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-5">
                          <i className="mdi mdi-package-variant text-muted" style={{ fontSize: '2.5rem' }}></i>
                          <h6 className="text-dark fw-bold mt-2">No AMC Items</h6>
                        </div>
                      )
                    ) : Array.isArray(inventoryData?.[inventoryTab]) &&
                      inventoryData[inventoryTab].length > 0 ? (
                      inventoryData[inventoryTab].map((item, idx) => (
                        <div
                          key={idx}
                          className="d-flex align-items-center border rounded-3 p-2 mb-2 bg-white shadow-sm"
                        >
                          <div
                            className="bg-light rounded p-1 d-flex align-items-center justify-content-center me-3"
                            style={{ width: '56px', height: '56px', flexShrink: 0 }}
                          >
                            <img
                              src={item?.img_url || noImage}
                              alt={item?.title}
                              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                            />
                          </div>
                          <div className="flex-grow-1 me-2">
                            <h6 className="mb-1 small fw-semibold">
                              {item?.title}
                              {item?.is_default_selection && (
                                <Badge color="success" className="ms-2 rounded-0" style={{ fontSize: '9px' }}>
                                  Default
                                </Badge>
                              )}
                            </h6>
                            <p className="text-muted mb-0" style={{ fontSize: '0.7rem' }}>
                              Sku: {item?.sku} · Qty: {item?.qty}
                            </p>
                          </div>
                          <span className="fw-bold text-dark text-nowrap">
                            {serviceOrderDetailData?.currency} {item?.price}
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="text-center py-5">
                        <i className="mdi mdi-package-variant text-muted" style={{ fontSize: '2.5rem' }}></i>
                        <h6 className="text-dark fw-bold mt-2">No Items Found</h6>
                      </div>
                    )}
                  </div>
                </>
              )}
            </OffcanvasBody>
          </Offcanvas>

          {/* Offcanvas for Feedback Rating Details */}
          <Offcanvas
            isOpen={feedbackDrawerOpen}
            toggle={() => setFeedbackDrawerOpen(false)}
            direction="end"
            style={{ width: '480px', backgroundColor: '#ffffff' }}
          >
            <div className="p-4 border-bottom bg-white sticky-top shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="bg-warning bg-opacity-10 p-2 rounded-3">
                    <i className="mdi mdi-star text-warning fs-4"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0 text-dark">Service Feedback</h5>
                    <p className="text-muted small mb-0">
                      {serviceOrderDetailData?.service_order_no}
                    </p>
                  </div>
                </div>
                <Button
                  type="button"
                  className="btn-close"
                  onClick={() => setFeedbackDrawerOpen(false)}
                  aria-label="Close"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                ></Button>
              </div>
            </div>

            <OffcanvasBody>
              {feedbackDetails ? (
                <>
                  {/* Overall rating */}
                  <div className="text-center border rounded-3 p-3 mb-4 bg-light">
                    <div className="mb-1">
                      {renderStars(feedbackDetails?.rating, '1.6rem')}
                    </div>
                    <h4
                      className="fw-bold mb-0"
                      style={{ color: getRatingColor(feedbackDetails?.rating) }}
                    >
                      {feedbackDetails?.rating} / 5
                    </h4>
                    {feedbackDetails?.created_at && (
                      <p className="text-muted small mb-0 mt-1">
                        Submitted on {feedbackDetails?.created_at}
                      </p>
                    )}
                  </div>

                  {/* Questions & answers */}
                  {Array.isArray(feedbackDetails?.questions) &&
                    feedbackDetails.questions.map((q, idx) => (
                      <div key={idx} className="mb-3">
                        <p className="fw-semibold mb-1">
                          {idx + 1}. {q?.question}
                        </p>
                        {q?.type === 'rating' ? (
                          <div>{renderStars(q?.answer)}</div>
                        ) : q?.answer ? (
                          <span
                            className="badge border px-2 py-1"
                            style={{
                              backgroundColor: '#f1f3f5',
                              color: '#495057',
                              borderColor: '#ced4da',
                            }}
                          >
                            {q.answer}
                          </span>
                        ) : (
                          <span className="text-muted small">No answer</span>
                        )}
                      </div>
                    ))}

                  {/* Customer remarks */}
                  <div className="mt-4">
                    <p className="fw-semibold mb-1">Customer Remarks</p>
                    {feedbackDetails?.comment ? (
                      <div className="border rounded-3 p-3 bg-light">
                        {feedbackDetails.comment}
                      </div>
                    ) : (
                      <span className="text-muted small">No remarks</span>
                    )}
                  </div>
                </>
              ) : (
                <div className="text-center py-5">
                  <i
                    className="mdi mdi-star-outline text-muted"
                    style={{ fontSize: '2.5rem' }}
                  ></i>
                  <h6 className="text-dark fw-bold mt-2">No Feedback Available</h6>
                </div>
              )}
            </OffcanvasBody>
          </Offcanvas>

          {/* Offcanvas for Make Free Service */}
          <Offcanvas
            isOpen={freeServiceOpen}
            toggle={() => setFreeServiceOpen(false)}
            direction="end"
            style={{ width: '480px', backgroundColor: '#ffffff' }}
          >
            <div className="p-4 border-bottom bg-white sticky-top shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-0">
                <div className="d-flex align-items-center gap-3">
                  <div className="bg-warning bg-opacity-10 p-2 rounded-3">
                    <i className="mdi mdi-gift-outline text-warning fs-4"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0 text-dark">Make Free Service</h5>
                    <p className="text-muted small mb-0">
                      {serviceOrderDetailData?.service_order_no}
                    </p>
                  </div>
                </div>
                <Button
                  type="button"
                  className="btn-close"
                  onClick={() => setFreeServiceOpen(false)}
                  aria-label="Close"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                ></Button>
              </div>
            </div>

            <OffcanvasBody>
              <form onSubmit={handleFreeServiceSubmit}>
                <FormGroup>
                  <Label>Remark*</Label>
                  <TextArea
                    className="form-control form-textArea"
                    value={freeServiceRemark}
                    onChange={(e) => setFreeServiceRemark(e.target.value)}
                    disabled={isSubmitting}
                  ></TextArea>
                  {freeServiceRemarkError && (
                    <div style={{ color: 'red', marginTop: '5px' }}>
                      {freeServiceRemarkError}
                    </div>
                  )}
                </FormGroup>

                <FormGroup check className="mt-3">
                  <Label check>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={freeServiceAck}
                      onChange={(e) => setFreeServiceAck(e.target.checked)}
                      disabled={isSubmitting}
                    />{' '}
                    I confirm that this service will be provided as a free
                    service.
                  </Label>
                  {freeServiceAckError && (
                    <div style={{ color: 'red', marginTop: '5px' }}>
                      {freeServiceAckError}
                    </div>
                  )}
                </FormGroup>

                <div className="mt-4 d-flex justify-content-end gap-2">
                  <Button
                    type="button"
                    color="light"
                    onClick={() => setFreeServiceOpen(false)}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button color="success" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </Button>
                </div>
              </form>
            </OffcanvasBody>
          </Offcanvas>

          {/* Offcanvas for Update Location */}
          <Offcanvas
            isOpen={updateLocationOpen}
            toggle={closeUpdateLocation}
            direction="end"
            style={{ width: '1200px' }}
          >
            <div className="p-3 border-bottom position-relative">
              <Button
                type="button"
                className="btn-close position-absolute end-0 top-0 m-3"
                onClick={closeUpdateLocation}
                aria-label="Close"
                style={{ backgroundColor: 'transparent', border: 'none' }}
              ></Button>
              <div className="d-flex flex-column align-items-center mt-3 text-center">
                <h5 className="fw-bold mb-2">Update Customer Location</h5>
              </div>
            </div>
            <OffcanvasBody className="p-0">
              <div className="p-3">
                <AddAddress
                  service_order_no={serviceOrderDetailData?.service_order_no}
                  showmapandAddress={true}
                  setShowmapandAddress={() => {}}
                  source="serviceOrder"
                  closeUpdateLocation={closeUpdateLocation}
                  initialData={{
                    latitude: serviceOrderDetailData?.customer_info?.latitude || '',
                    longitude: serviceOrderDetailData?.customer_info?.longitude || '',
                    buildingName: serviceOrderDetailData?.customer_info?.building || '',
                    streetName: serviceOrderDetailData?.customer_info?.street || '',
                    flatNo: serviceOrderDetailData?.customer_info?.flat || '',
                    floorNumber: serviceOrderDetailData?.customer_info?.floor || '',
                    areaName: serviceOrderDetailData?.customer_info?.area || '',
                    nearestLandMark: serviceOrderDetailData?.customer_info?.land_mark || '',
                    companyName: serviceOrderDetailData?.customer_info?.company_name || '',
                    trnNo: serviceOrderDetailData?.customer_info?.trn_no || '',
                  }}
                />
              </div>
            </OffcanvasBody>
          </Offcanvas>

          {/* WhatsApp Confirmation Modal */}
          <Modal
            isOpen={whatsappConfirmModal}
            toggle={toggleWhatsappConfirmModal}
            centered
          >
            <ModalHeader toggle={toggleWhatsappConfirmModal}>
              Confirm WhatsApp Action
            </ModalHeader>
            <ModalBody className="text-center p-4">
              <div className="mb-4">
                <i
                  className="mdi mdi-whatsapp text-success"
                  style={{ fontSize: '3rem' }}
                ></i>
              </div>
              <h5>Send Location Update Link?</h5>
              <p className="text-muted">
                A link will be sent to the customer at{' '}
                <strong>
                  {serviceOrderDetailData?.customer_info?.mobile || 'N/A'}
                </strong>{' '}
                to update their location.
              </p>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                outline
                onClick={toggleWhatsappConfirmModal}
              >
                Cancel
              </Button>
              <Button
                color="success"
                onClick={() => {
                  sendWhatsAppMessage({
                    customer_name:
                      serviceOrderDetailData?.customer_info?.customer_name,
                    service_no: serviceOrderDetailData?.service_order_no,
                    mobile: serviceOrderDetailData?.customer_info?.mobile,
                  });
                  toast.success('WhatsApp link request initiated');
                  toggleWhatsappConfirmModal();
                }}
              >
                Send Link
              </Button>
            </ModalFooter>
          </Modal>

          <Offcanvas
            isOpen={orderDetailsOpen}
            toggle={toggleOrderDetails}
            direction="end"
            style={{ width: '500px' }}
          >
            <div className="p-3 border-bottom position-relative">
              <Button
                type="button"
                className="btn-close position-absolute end-0 top-0 m-3"
                onClick={toggleOrderDetails}
                aria-label="Close"
                style={{ backgroundColor: 'transparent', border: 'none' }}
              ></Button>
              <div className="d-flex flex-column align-items-center mt-3 text-center">
                <h5 className="fw-bold mb-2">Update Order Details</h5>
              </div>
            </div>
            <OffcanvasBody>
              <form onSubmit={handleOrderUpdateSubmit}>
                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>Complaint No</Label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderForm.complaint_no}
                        onChange={(e) => setOrderForm({ ...orderForm, complaint_no: e.target.value })}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>LS Order No</Label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderForm.ls_order_no}
                        onChange={(e) => setOrderForm({ ...orderForm, ls_order_no: e.target.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>Model No</Label>
                      <select
                        className="form-control form-select"
                        value={orderForm.model_no}
                        onChange={(e) => setOrderForm({ ...orderForm, model_no: e.target.value })}
                      >
                        <option value="">Select Model</option>
                        {modelList.map((model, index) => (
                          <option key={index} value={model}>
                            {model}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>Serial No</Label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderForm.serial_no}
                        onChange={(e) => setOrderForm({ ...orderForm, serial_no: e.target.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>SKU</Label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderForm.sku}
                        onChange={(e) => setOrderForm({ ...orderForm, sku: e.target.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>Warranty (months)</Label>
                      <input
                        type="text"
                        className="form-control"
                        value={orderForm.warranty}
                        onChange={(e) => setOrderForm({ ...orderForm, warranty: e.target.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>Installation Date</Label>
                      <Flatpickr
                        className="form-control"
                        options={{
                          dateFormat: "Y-m-d",
                          altInput: true,
                          altFormat: "F j, Y",
                        }}
                        value={orderForm.installation_date}
                        onChange={(date) => setOrderForm({ ...orderForm, installation_date: date[0] })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>Warranty End Date</Label>
                      <Flatpickr
                        className="form-control"
                        options={{
                          dateFormat: "Y-m-d",
                          altInput: true,
                          altFormat: "F j, Y",
                        }}
                        value={orderForm.warranty_end_date}
                        onChange={(date) => setOrderForm({ ...orderForm, warranty_end_date: date[0] })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>AMC Start Date</Label>
                      <Flatpickr
                        className="form-control"
                        options={{
                          dateFormat: "Y-m-d",
                          altInput: true,
                          altFormat: "F j, Y",
                        }}
                        value={orderForm.amc_start_date}
                        onChange={(date) => setOrderForm({ ...orderForm, amc_start_date: date[0] })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label>AMC End Date</Label>
                      <Flatpickr
                        className="form-control"
                        options={{
                          dateFormat: "Y-m-d",
                          altInput: true,
                          altFormat: "F j, Y",
                        }}
                        value={orderForm.amc_end_date}
                        onChange={(date) => setOrderForm({ ...orderForm, amc_end_date: date[0] })}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <div className="mt-4 d-flex justify-content-end gap-2">
                  <Button
                    color="secondary"
                    outline
                    type="button"
                    onClick={toggleOrderDetails}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Updating...' : 'Update Details'}
                  </Button>
                </div>
              </form>
            </OffcanvasBody>
          </Offcanvas>

        </Container>
        <Toaster position="top-right" reverseOrder={false} />
      </div>
    </>
  );
};

export default ServiceOrdersDetails;
